module.exports = __webpack_public_path__ + "media/images/icons/character-development_02-8f657b9279283b8854c4a2c98a1d3698.svg";